<div ng-controller="automateDateSettingsController as automateDateSettingsCtrl">
    <c-auto-form config="automateDateSettingsCtrl.autoFormConfig"></c-auto-form>
</div>